if (!customElements.get("freshchat-button")) {
    class FreshChatButton extends HTMLElement {
        connectedCallback() {
            this.addEventListener("click", this.loadScript.bind(this));
        }

        loadScript() {
            const freshchatScript = document.createElement("script");
            freshchatScript.type = "text/javascript";
            freshchatScript.src = "https://wchat.freshchat.com/js/widget.js";
            this.pageOverlay.classList.add("is-visible");
            document
                .getElementsByTagName("head")[0]
                .appendChild(freshchatScript);
            if (freshchatScript.readyState) {
                // only required for IE <9
                script.onreadystatechange = () => {
                    if (
                        freshchatScript.readyState === "loaded" ||
                        freshchatScript.readyState === "complete"
                    ) {
                        freshchatScript.onreadystatechange = null;
                        this.initFcWidget();
                    }
                };
            } else {
                //Others
                freshchatScript.onload = () => {
                    this.initFcWidget();
                };
            }
        }

        initFcWidget() {
            // Read data attributes at init time (after cache-hydration.js has set them)
            const customerId = this.dataset?.customerId || this.customerId;
            const firstName = this.dataset?.firstName || this.firstName;
            const email = this.dataset?.email || this.email;
            const phone = this.dataset?.phone || this.phone;

            const fcData = {
                token: "af507456-dd69-4412-b368-78f0cabfe453",
                host: "https://wchat.freshchat.com",
                config: {
                    headerProperty: {
                        direction: "rtr",
                    },
                },
            };

            if (customerId) {
                fcData.externalId = customerId;
            }

            if (firstName) {
                fcData.firstName = firstName;
            }

            if (email) {
                fcData.email = email;
            }

            if (phone) {
                fcData.phone = phone;
            }
            fcData.lastName = "";

            window.fcWidget.init(fcData);
            window.fcWidget.open();
            window.fcWidget.show();
            setTimeout(() => {
                this.style.display = "none";
                this.pageOverlay.classList.remove("is-visible");
            }, 500);
        }

        get pageOverlay() {
            return document.querySelector(".page-overlay");
        }
    }

    customElements.define("freshchat-button", FreshChatButton);
}
